export default __webpack_public_path__ + "static/media/trade_anything.fb7fe92d.svg";